import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_TERRITORIES_BATCH_LOG: TDatadogErrorLog = {
  from: 'src/modules/brands/common/hooks/use-brand-niche-data-batch/index.ts',
  name: 'Get territories batch for brand niches',
  message: 'Batch fetch multiple territories for brand niche data',
}
